import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Outlet } from "react-router";
// v8 removed `react-router-dom`; the DOM-aware `RouterProvider` (the one that
// pairs with `createBrowserRouter`) now lives at `react-router/dom`, while the
// bare `react-router` export is the framework/non-DOM variant.
import { RouterProvider } from "react-router/dom";


import { initSentry } from "@/lib/sentry";
import { routes } from "./routes";
import { Root } from "./root";
import { ScrollRestoration } from "@/components/core/scroll-restoration";

initSentry();

/**
 * Application entry point.
 * Responsible solely for mounting the component tree to the DOM.
 */
const root = createRoot(document.querySelector("#root")!);

const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<Root>
				<ScrollRestoration />
				<Outlet />
			</Root>
		),
		children: [...routes],
	},
]);

root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
